import Vue from "vue";
import Vuex from "vuex";

// import createPersistedState from "vuex-persistedstate";

import { UserState } from "./modules/user";
import { AppState } from "./modules/app";

Vue.use(Vuex);

interface RootState {
  appState: AppState;
  userState: UserState;
  // dokterState: DokterState;
}

export default new Vuex.Store<RootState>({
  // plugins: [createPersistedState({ storage: window.sessionStorage })] // !debug ? [createPersistedState({ storage: window.sessionStorage })] : [],
});
